/* eslint-disable no-unused-vars */
import React from 'react';
import Image from 'next/image';
import Grid from '@mui/material/Unstable_Grid2';
import { styled } from '@mui/system';
import {
  Typography,
  Container,
  Box,
  Paper,
  Stack,
  Divider,
} from '@mui/material';
import { tokens } from '../../../tokens';
import AboutCryptoCVVIGauge from './AboutCryptoCvviGauge';
import AboutCryptoCVVIDesc from './AboutCryptoCVVIDesc';
import ExchangeCVVI from '../../searchresults/cvvi/exchanges/ExchangeCVVI';
import DexCVVI from '../../searchresults/cvvi/dex/DexCVVI';
import ProtocolCVVI from '../../searchresults/cvvi/protocol/ProtocolCVVI';

const Item = styled(Paper)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  // ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  borderColor: 'transparent',
}));

const IntroTypo = styled(Typography)(() => ({
  color: tokens.token_black,
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontWeight: 400,
  fontSize: '1.75rem',
  letterSpacing: -0.5,
  lineHeight: '2.125rem',
  paddingTop: '24px',
  textAlign: 'center',
  opacity: 1,
}));

const BlockTypo = styled(Typography)(() => ({
  fontFamily: 'play',
  opacity: 1,
  fontSize: '1.00rem',
  fontWeight: 700,
  lineHeight: '1.25rem',
  textAlign: 'center',
  paddingLeft: 0,
  whiteSpace: 'wrap',
  color: tokens.palette_primary,
}));
const IndexTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  opacity: 1,
  fontSize: '1.5rem',
  fontWeight: 500,
  lineHeight: '1.75rem',
  textAlign: 'left',
  paddingLeft: 0,
  whiteSpace: 'wrap',
  color: tokens.token_typography_headline,
}));

function ColorText({ children }) {
  return <span style={{ color: tokens.palette_secondary }}>{children}</span>;
}
const SectionTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  opacity: 1,
  fontSize: '1.25rem',
  fontWeight: 500,
  lineHeight: '1.50rem',
  textAlign: 'left',
  paddingLeft: 0,
  whiteSpace: 'wrap',
  color: tokens.token_black,
}));

const RegTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  opacity: 1,
  display: 'inline-block',
  fontSize: '1.00rem',
  fontWeight: 400,
  fontStyle: 'normal',
  lineHeight: '1.25rem',
  letterSpacing: 'normal',
  // textAlign: 'left',
  color: tokens.token_grey_700,
}));

function ViceAndVirtuMain() {
  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          maxWidth: '925px',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '240px',
        }}
      >
        <Grid container spacing={0.5} flexDirection={{}}>
          <Grid xs={12}>
            <Item variant="outlined">
              <IntroTypo>
                {/* Our mission is to be the&nbsp; */}
                <strong>{/* <ColorText>first</ColorText> */}</strong>
                {/* &nbsp;place people search for the most current peer-to-peer
              conversations on and about blockchain activities. */}
              </IntroTypo>
            </Item>
          </Grid>

          <Grid
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Item variant="outlined">
              <Stack direction="row">
                {/* <BlockTypo>
                  <ColorText>b</ColorText>lockquiry's
                </BlockTypo>
                &nbsp; */}
                <IndexTypo>Crypto Vice and Virtue Index™</IndexTypo>
              </Stack>
              <RegTypo>What is driving crypto economy now?</RegTypo>
            </Item>
          </Grid>

          <Grid
            xs={6}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              width: 'auto',
              paddingRight: 0,
            }}
          >
            <AboutCryptoCVVIGauge />
          </Grid>
          <Grid
            xs={6}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              width: 'auto',
              paddingLeft: 0,
            }}
          >
            <AboutCryptoCVVIDesc />
          </Grid>

          <Grid
            xs={12}
            // md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Item variant="outlined" sx={{ marginTop: '4px' }}>
              <RegTypo>
                Crypto Vice and Virtue Index™ breaks down further into layers
                of: Crypto <b>Exchanges</b> Vice and Virtue Index™, Crypto{' '}
                <b>DEX</b> Vice and Virtue Index™, and Crypto <b>Blockchain</b>{' '}
                Vice and Virtue Index™. The index breakdown aims to allow users
                to understand the viability, security and safety differences
                between the protocol/technology layer vs. the decentralized
                application layer vs. the centralized application layer.{' '}
              </RegTypo>
            </Item>
          </Grid>
          <Grid
            xs={12}
            // md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Item variant="outlined" sx={{ marginBottom: '4px' }}>
              <RegTypo>
                Within each layer top five entities, projects and protocols by
                bitcoin and ethereum transaction volume are assigned their
                individual index.
              </RegTypo>
            </Item>
          </Grid>
          <Grid
            xs={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '300px',
              // margin: '2px',
            }}
          >
            <ExchangeCVVI />
          </Grid>
          <Grid
            xs={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minWidth: '300px',
              // margin: '2px',
            }}
          >
            <DexCVVI />
          </Grid>
          <Grid
            xs={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minWidth: '300px',
              // margin: '2px',
            }}
          >
            <ProtocolCVVI />
          </Grid>
          <Grid
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Stack>
              <SectionTypo sx={{ marginTop: '20px', marginBottom: '10px' }}>
                Vice and Virtue FAQs
              </SectionTypo>
              <RegTypo sx={{ marginBottom: '8px', marginTop: '16px' }}>
                <b>What is the Crypto Vice and Virtue Index™?</b>
              </RegTypo>
              <RegTypo>
                The Crypto Vice and Virtue Index™ is a way to gauge the trust of
                the crypto community in the overall viability, safety, and
                security of the crypto ecosystem.
              </RegTypo>
              <RegTypo sx={{ marginBottom: '8px', marginTop: '16px' }}>
                <b>How is Crypto Vice and Virtue Index™ Calculated?</b>
              </RegTypo>
              <RegTypo>
                The Crypto Vice and Virtue Index™ is a compilation of seven
                indicators measuring various aspects of participants' sentiment
                and blockchain activity. The index tracks how much these
                individual indicators deviate from their averages compared to
                how much they normally diverge. The index gives each indicator
                equal weighting in calculating a score from 0 to 100, with 100
                representing maximum virtue and 0 signaling maximum vices.
              </RegTypo>
              <RegTypo sx={{ marginBottom: '8px', marginTop: '16px' }}>
                <b>
                  Which indicators make up the Crypto Vice and Virtue Index™?
                </b>
              </RegTypo>
              <RegTypo>
                Indicators that make up the Crypto Vice and Virtue Index™
                include: Twitter sentiment, Reddit sentiment, general news
                sentiment, Crypto Panic news sentiment, Chainabuse reporting
                blockquiry reporting and overall transaction volume for bitcoin
                and ethereum.
              </RegTypo>
              <RegTypo sx={{ marginBottom: '8px', marginTop: '16px' }}>
                <b>How often is Crypto Vice and Virtue Index™ Calculated?</b>
              </RegTypo>
              <RegTypo>
                Every component and the Index are calculated as soon as new data
                becomes available.
              </RegTypo>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default ViceAndVirtuMain;
